export default {
  routeFullPath() {
    return this.$route.fullPath
  },

  homepage() {
    return this.$route.name === 'homewlang' || this.$route.name === 'home'
  },

  showListObjectInfoVertically() {
    return this.homepage || this.isMobileView || this.dialogView
  },

  pageName() {
    return this.$route.name
  },

  isObjectPage() {
    return this.pageName === 'object'
  },

  page() {
    return this.searchFilters.page
  },

  sortBy() {
    return this.searchFilters.sortBy
  },

  isLargeMobile() {
    return this.$store.state.windowWidth >= 360
  },

  isDesktopView() {
    // Note - instead of using isFacebookApp having a timer to check
    // if window inner width has changed
    // Facebook Mobile browser has issue where it gives wrong resolution
    // And even when resolution changes it does not trigger resize
    // if (isFacebookApp() && this.windowWidth < 1200) {
    //   return false
    // }
    return this.$store.state.windowWidth >= 960
    // return this.$vuetify.breakpoint.mdAndUp && this.windowWidth >= 960
  },

  isMobileView() {
    return !this.isDesktopView
  },

  contactOptions() {
    const subject = this.selectedObject ? this.selectedObject.idname : ''
    return [
      {
        link: 'mailto:' + this.$i18n.t('contact_email') + '?subject=' + subject,
        title_translation: 'e-mail',
        colon: true,
        title: this.$i18n.t('contact_email'),
        icon: 'fa-envelope',
      },
      {
        link:
          'https://wa.me/' +
          this.$i18n.t('whatsapp_number') +
          '?text=' +
          subject,
        title: '',
        title_translation: 'send_whatsapp',
        icon: 'fab fa-whatsapp',
      },
      {
        link: 'tel:' + this.$i18n.t('phone_number').replace(' ', ''),
        title_translation: 'call',
        title: ' ' + this.$i18n.t('phone_number'),
        icon: 'fa-phone',
      },
      {
        link: 'sms:' + this.$i18n.t('phone_number').replace(' ', ''),
        title_translation: 'send_sms',
        title: '',
        icon: 'fa-sms',
      },
    ]
  },

  selectedPersonsText() {
    const selectedText = this.personTypes
      .map((personType, index) => {
        if (this.bookingData[personType]) {
          const count = this.bookingData[personType]
          if (count > 0) {
            const nameField =
              count > 1
                ? personType
                : personType.substring(0, personType.length - 1)
            return this.bookingData[personType] + ' ' + this.$i18n.t(nameField)
          }
          return null
        }
        return 0
      })
      .filter((name) => name)
      .join(', ')

    return selectedText || this.$i18n.t('select')
  },
}
